import { DROPDOWN_ORG_ID } from "@/components/fastshift/src/state";
import { CustomerDomainOrg } from "@/components/fastshift/src/state/types";

// defined individually to avoid undefined typing issues
export const NO_ORG_FILTER: CustomerDomainOrg = {
    orgId: DROPDOWN_ORG_ID.NO_ORG,
    orgName: "No Org" // do not display this name on UI
};

export const OTHER_ORG_FILTER: CustomerDomainOrg = {
    orgId: DROPDOWN_ORG_ID.OTHER_ORGS,
    orgName: "Other Cloud Orgs" // do not display this name on UI
};

export const DEFAULT_ORG_FILTERS_ORDER: CustomerDomainOrg[] = [
    OTHER_ORG_FILTER,
    NO_ORG_FILTER
];
